import React, { useRef } from 'react';
import styled from 'styled-components';

import AffiliateFooter from 'modules/affiliateOffer/components/AffiliateFooter';

import { useCorporateContext } from '../CorporateContext';
import { selectMonthPeriod } from '../helpers';
import { CorporateAudience } from '../types';

import GroupOfferHeader from './GroupOfferHeader';
import BehindTheAdviceSection from './sections/BehindTheAdviceSection';
import CoachHeroSection from './sections/CoachHeroSection';
import FAQSection from './sections/FAQSection';
import { Eyebrow, SectionDivider } from './sections/headings';
import HowItWorksSection from './sections/HowItWorksSection';
import MembershipSection from './sections/MembershipSection';
import SixAreasSection from './sections/SixAreasSection';
import SuccessStoriesSection from './sections/SuccessStoriesSection';
import Swoosh from './Swoosh';

const OfferIntroContent = ({ isLoading }: { isLoading: boolean }) => {
  const { offerTerm, audience } = useCorporateContext();

  const heroRef = useRef<HTMLDivElement>(null);

  const isEmployee = audience === CorporateAudience.Employee;
  const monthPeriod = selectMonthPeriod(offerTerm);
  const notFound = !isLoading && !offerTerm;

  return (
    <Container>
      <Swoosh heroRef={heroRef} />
      <GroupOfferHeader
        monthPeriod={monthPeriod}
        withForm={!isLoading}
        notFound={notFound}
      />
      <Layer ref={heroRef}>
        <CoachHeroSection
          videoSrc={
            isEmployee
              ? '/Shido_Explainer_Employee.mp4'
              : '/Shido_Explainer_Consumer.mp4'
          }
        />
      </Layer>
      <Body>
        <BehindTheAdviceSection />
        <SectionDivider />
        <SuccessStoriesSection
          eyebrow={<Eyebrow>Testimonials</Eyebrow>}
          title="Trusted by 1000’s of people like you"
          withFooter={false}
          withSubtitle={false}
        />
        <SectionDivider $marginTop={false} $marginBottom />
        <HowItWorksSection />
        <SectionDivider $marginBottom />
        <SixAreasSection />
        <SectionDivider />
        <MembershipSection
          subtitle={`All of Shido${
            monthPeriod ? ` for ${monthPeriod}` : ''
          }. No card, nothing to cancel.`}
        />
        {isEmployee && (
          <>
            <SectionDivider />
            <FAQSection />
          </>
        )}
      </Body>
      <AffiliateFooter />
    </Container>
  );
};

const Container = styled.main`
  width: 100%;
  position: relative;
  overflow: clip;
  background-color: ${({ theme }) => theme.colors.cream};
`;

// Positioned so the sections paint over the fixed swoosh.
const Layer = styled.div`
  position: relative;
`;

const Body = styled(Layer)`
  padding-bottom: 80px;
`;

export default OfferIntroContent;
